import { render, staticRenderFns } from "./TileFormComponent.vue?vue&type=template&id=0567c1c2&"
import script from "./TileFormComponent.vue?vue&type=script&lang=ts&"
export * from "./TileFormComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports